// src/App.jsx
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";

// Customer pages
import Home          from "./pages/customer/Home";
import Categories from "./pages/customer/Categories";
import Products      from "./pages/customer/Products";
import ProductDetail from "./pages/customer/ProductDetail";
import Cart          from "./pages/customer/Cart";
import Checkout      from "./pages/customer/Checkout";
import OrderSuccess  from "./pages/customer/OrderSuccess";
import Orders        from "./pages/customer/Orders";
import OrderDetail   from "./pages/customer/OrderDetail";
import About         from "./pages/customer/About";
import Blog          from "./pages/customer/Blog";
import BlogDetail    from "./pages/customer/BlogDetail";
import Contact       from "./pages/customer/Contact";
import Privacy       from "./pages/customer/Privacy";
import Terms         from "./pages/customer/Terms";
import Login         from "./pages/customer/Login";
import Register      from "./pages/customer/Register";
import ForgotPassword from "./pages/customer/ForgotPassword";
import WishlistPage from "./pages/customer/WishlistPage";
import Refundpolicy from "./pages/customer/Refundpolicy";
import ShippingPolicy from "./pages/customer/ShippingPolicy";
import Careers        from "./pages/customer/Careers";
import CareerDetail from "./pages/customer/CareerDetail";
import MyAccount from "./pages/customer/MyAccount";

// Admin pages
import AdminLayout      from "./pages/admin/AdminLayout";
import Dashboard        from "./pages/admin/Dashboard";
import AdminProducts    from "./pages/admin/AdminProducts";
import AdminCategories  from "./pages/admin/AdminCategories";
import AdminOrders      from "./pages/admin/AdminOrders";
import AdminOrderUnit   from "./pages/admin/AdminOrderUnit";
import AdminUsers       from "./pages/admin/AdminUsers";
import AdminBlogs       from "./pages/admin/AdminBlogs";
import AdminTestimonials       from "./pages/admin/AdminTestimonials";
import AdminFaqs from "./pages/admin/AdminFaqs";
import AdminSocialLinks from "./pages/admin/AdminSocialLinks";
import AdminBanners     from "./pages/admin/AdminBanners";
import AdminAbout       from "./pages/admin/AdminAbout";
import AdminContacts    from "./pages/admin/AdminContacts";
import Physicalbill from "./pages/admin/Physicalbill";
import AdminCareers  from "./pages/admin/AdminCareers";
import AdminCareerApply from "./pages/admin/AdminCareerApply";

// Guards
import PrivateRoute     from "./components/common/PrivateRoute";
import AdminRoute       from "./components/common/AdminRoute";

// Customer layout
import CustomerLayout   from "./components/customer/CustomerLayout";

import "./styles/index.css";
function ScrollToTopHandler() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTopHandler />

          <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
          <Routes>
            {/* ── Customer Routes ─────────────────────────────── */}
            <Route path="/" element={<CustomerLayout />}>
              <Route index          element={<Home />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="products"        element={<Products />} />
              <Route path="products/:id"    element={<ProductDetail />} />
              <Route path="/wishlist" element={<WishlistPage />} />
              <Route path="cart"            element={<Cart />} />
              <Route path="checkout"        element={<PrivateRoute><Checkout /></PrivateRoute>} />
             <Route path="account" element={<MyAccount />} />
              <Route path="order-success"   element={<PrivateRoute><OrderSuccess /></PrivateRoute>} />
              <Route path="orders"          element={<PrivateRoute><Orders /></PrivateRoute>} />
              <Route path="orders/:id"      element={<PrivateRoute><OrderDetail /></PrivateRoute>} />
              <Route path="about"           element={<About />} />
              <Route path="blog"            element={<Blog />} />
              <Route path="blog/:id"        element={<BlogDetail />} />
              <Route path="contact"         element={<Contact />} />
              <Route path="careers" element={<Careers />} />
              <Route path="careers/:id" element={<CareerDetail />} />
              <Route path="privacy"         element={<Privacy />} />
              <Route path="terms"           element={<Terms />} />
              <Route path="/refund-policy"   element={<Refundpolicy />} />
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
              <Route path="login"           element={<Login />} />
              <Route path="register"        element={<Register />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
            </Route>

            {/* ── Admin Routes ─────────────────────────────────── */}
            <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
              <Route index            element={<Dashboard />} />
              <Route path="products"  element={<AdminProducts />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="orders"    element={<AdminOrders />} />
              <Route path="order-unit" element={<AdminOrderUnit />} />
              <Route path="users"     element={<AdminUsers />} />
              <Route path="blogs"     element={<AdminBlogs />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="faqs" element={<AdminFaqs />} />
              <Route path="social-links" element={<AdminSocialLinks />} />
              <Route path="careers"   element={<AdminCareers />} />
              <Route path="career-applications" element={<AdminCareerApply />} />
              <Route path="banners"   element={<AdminBanners />} />
              <Route path="about"     element={<AdminAbout />} />
              <Route path="contacts"  element={<AdminContacts />} />
              <Route path="/admin/bills" element={<Physicalbill />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
